export const CONNECTIONS_COUNT = 'CONNECTIONS_COUNT';
export const LAST_SYNC_STATS = 'LAST_SYNC_STATS';
export const LEAD_SCORE_SETTINGS = 'LEAD_SCORE_SETTINGS';
export const WEB_TRACKING_COUNTERS = 'WEB_TRACKING_COUNTERS';
export const ERRORS = 'ERRORS';
export const INTEGRATION_TO_CONNECT = 'INTEGRATION_TO_CONNECT';
